const MAX_CALLS = 3;
const SESSION_TTL_MS = 60 * 60 * 1000; // 1 hour

export interface SessionData {
  prevSessionId?: string;
  sessionId: string;
  callCount: number;
  createdAt: number;
  maxCalls: number;
}

export class SessionManager {
  static createNewSession(
    maxCalls: number = MAX_CALLS,
    prevSessionId: string = ""
  ): SessionData {
    return {
      sessionId: crypto.randomUUID(),
      prevSessionId,
      callCount: 0,
      createdAt: Date.now(),
      maxCalls,
    };
  }

  static getNextRequest(session: SessionData): {
    session: SessionData;
    requestId: string;
    isNewSession: boolean;
  } {
    const now = Date.now();
    let isNewSession = false;
    let newSession = session;

    const expired =
      now - session.createdAt > SESSION_TTL_MS ||
      session.callCount >= session.maxCalls;

    if (expired) {
      newSession = SessionManager.createNewSession(
        MAX_CALLS,
        session.sessionId
      );
    }

    if (newSession.callCount >= 2) {
      isNewSession = true;
    }

    newSession = { ...newSession, callCount: newSession.callCount + 1 };

    const requestId = `req${String(newSession.callCount).padStart(3, "0")}`;

    return { session: newSession, requestId, isNewSession };
  }

  static stopSession(session: SessionData): SessionData {
    const remaining = Math.max(session.maxCalls - session.callCount, 0);
    return SessionManager.createNewSession(remaining, session.sessionId);
  }

  static startNewTopic(session?: SessionData): SessionData {
    return SessionManager.createNewSession(MAX_CALLS, session?.sessionId ?? "");
  }
}
